import React, { useState, useEffect, useRef } from "react";

import { toast } from "react-toastify";

import axios from "@app/lib/axios";

import * as Constant from "@app/Constant.js";
import * as commonData from "@app/lib/common_data";
import utility from "@app/lib/utility";

import { CardStatBooks, NurseryList, ClassList } from "./Components/tomobooks";

const baseTotal = { install: 0, accessYear: 0, accessMonth: 0, accessMonthAvg: 0, playYear: 0, playMonth: 0, playMonthAvg: 0 };
const StatOldTomobooksParent = ({}) => {
    const [loadingData, setLoadingData] = useState(true);
    const loginBranchInfo = utility.getLoginBranchInfo();
    const [branches, setBranches] = useState(false);
    const [selectedBranch, setBranch] = useState(loginBranchInfo ? loginBranchInfo : null);
    const [dataAll, setDataAll] = useState(false);
    const [total, setTotal] = useState({ ...baseTotal });
    const [data, setData] = useState(false);
    const [dataNursery, setDataNursery] = useState(false);
    const [selectedNursery, setNursery] = useState(false);
    const [totalNursery, setTotalNursery] = useState({ ...baseTotal });
    useEffect(() => {
        if (!branches && !loginBranchInfo) {
            commonData.getBranchList(axios, (err, list) => {
                if (!err) {
                    setBranches(list);
                    getData(list);
                } else {
                    toast.err(err);
                }
            });
        } else {
            getData();
        }
        return () => {};
    }, []);

    const getData = (branches) => {
        const branchId = loginBranchInfo ? loginBranchInfo.id : 0;
        axios({
            method: "get",
            url: `${Constant.API_DOMAIN}/api/stat_old/tomobooks/${branchId}`,
        })
            .then((res) => {
                const result = res.data;
                const _data = { ...data };
                _data.list = result.list || [];
                setDataAll(_data.list);
                filterData(_data.list, branches, selectedBranch);
                setLoadingData(false);
            })
            .catch((error) => {
                console.log(error);
                setLoadingData(false);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    const getDataNursery = (branchId, nurseryId) => {
        axios({
            method: "get",
            url: `${Constant.API_DOMAIN}/api/stat_old/tomobooks/${branchId}/nursery/${nurseryId}`,
        })
            .then((res) => {
                const result = res.data;
                const _data = { ...data };
                _data.list = result.list || [];
                setDataNursery(_data.list);
                filterDataNursery(_data.list);
                setLoadingData(false);
            })
            .catch((error) => {
                console.log(error);
                setLoadingData(false);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    const onSelectBranch = (e) => {
        const { value } = e.target;
        if (value == 0) {
            setBranch(null);
        } else {
            const selected = branches.find((b) => b.id == value);
            setBranch(selected);
        }
    };

    const onSelectNursery = (branchId, nurseryId, nurseryName) => {
        setNursery({branchId: selectedBranch ? selectedBranch.id : branchId, id: nurseryId, name: nurseryName});
    };

    useEffect(() => {
        if (branches) {
            filterData(dataAll, branches, selectedBranch);
        }
        return () => {};
    }, [selectedBranch]);

    useEffect(() => {
        if (selectedNursery) {
            getDataNursery(selectedNursery.branchId, selectedNursery.id);
        }
        return () => {};
    }, [selectedNursery]);

    const filterData = (list, branchList, selectedBranch) => {
        let newData = [];
        let newTotal = { ...baseTotal };
        if (!selectedBranch) {
            newData = list ? list : [];
        } else {
            if (list) {
                list.forEach((d) => {
                    if (d.branch_id == selectedBranch.id) {
                        newData.push(d);
                    }
                });
            }
        }
        if (newData && newData.length > 0) {
            newData.forEach((s) => {
                if (branchList) {
                    const branch = branchList.find((b) => b.id == s.branch_id);
                    s.branchName = branch ? branch.name : "";
                } else {
                    if (loginBranchInfo) {
                        s.branchName = loginBranchInfo.name;
                    } else {
                        s.branchName = "";
                    }
                }
                if(!s.access) {
                    s.access = 0;
                }
                if(!s.play) {
                    s.play = 0;
                }
                newTotal.install += (s.install || 0);
                newTotal.accessYear += (s.access || 0);
                newTotal.accessMonth += (s.last_30_access || 0);
                newTotal.playYear += (s.play || 0);
                newTotal.playMonth += (s.last_30_play || 0);
                s.accessMonthTotal = 0;
                s.playMonthTotal = 0;
                if (s.install) {
                    s.accessMonthTotal = s.last_30_access;
                    s.playMonthTotal = s.last_30_play;
                }
            });
            if (newTotal.install) {
                newTotal.accessMonthAvg = (newTotal.accessMonth / newTotal.install).toFixed(1);
                newTotal.playMonthAvg = (newTotal.playMonth / newTotal.install).toFixed(1);
            }
        }
        setData(newData);
        setTotal(newTotal);
    };

    const filterDataNursery = (list) => {
        let newData = list ? list : [];
        let newTotal = { ...baseTotal };
        if (newData && newData.length > 0) {
            newData.forEach((s) => {
                newTotal.install += s.install || 0;
                newTotal.accessYear += s.access || 0;
                newTotal.accessMonth += s.last_30_access || 0;
                newTotal.playYear += s.play || 0;
                newTotal.playMonth += s.last_30_play || 0;
                s.accessMonthTotal = 0;
                s.playMonthTotal = 0;
                if (s.install) {
                    s.accessMonthTotal = s.last_30_access;
                    s.playMonthTotal = s.last_30_play;
                }
            });
            if (newTotal.install) {
                newTotal.accessMonthAvg = (newTotal.accessMonth / newTotal.install).toFixed(1);
                newTotal.playMonthAvg = (newTotal.playMonth / newTotal.install).toFixed(1);
            }
        }
        setDataNursery(newData);
        setTotalNursery(newTotal);
    };

    const onViewBack = () => {
        setDataNursery(false);
        setNursery(false);
        setTotalNursery({...baseTotal});
    }

    return (
        <div className="dashboard-wrapper">
            <div className="dashboard-ecommerce">
                <div className="container-fluid dashboard-content bg-white box-shadow-down pb-2">
                    <div className="row">
                        {selectedNursery && (
                            <div className="col-xl-1 col-lg-3 col-md-3 col-sm-3 col-4" style={{ minWidth: "59px", maxWidth: "59px", marginTop: "-5px" }}>
                                <button
                                    className="btn btn-default"
                                    style={{
                                        border: "0px",
                                        width: "44px",
                                    }}
                                    type="button"
                                    onClick={onViewBack}
                                >
                                    <span className="fa fa-lg fa-chevron-left" aria-hidden="true" />
                                </button>
                            </div>
                        )}
                        <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                            <div className="page-header">
                                <h2 className="pageheader-title">
                                    별별책방(부모) 사용 통계 
                                    {!loginBranchInfo && selectedBranch && !selectedNursery ? ` - ${selectedBranch.name}` : ""}
                                    {selectedNursery ? ` - ${selectedNursery.name}` : ""}
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-fluid dashboard-content">
                    <div className="row">
                        <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                            {branches && (
                                <select name="branch_id" value={selectedBranch ? selectedBranch.id : 0} className="form-control" onChange={onSelectBranch} disabled={selectedNursery != false}>
                                    <option key="branchOption_0" value="0">
                                        전체
                                    </option>
                                    {branches.map((branch) => {
                                        return (
                                            <option key={"branchOption_" + branch.id} value={branch.id}>
                                                {branch.name}
                                            </option>
                                        );
                                    })}
                                </select>
                            )}
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-xl col-lg-4 col-md-6 col-sm-6 col-12">
                            <CardStatBooks title="앱 사용자 수" total={selectedNursery ? totalNursery.install : total.install} titleBgClass="bg-tomoenglish" />
                        </div>
                        <div className="col-xl col-lg-4 col-md-6 col-sm-6 col-12">
                            <CardStatBooks title="연간 앱 실행 수" total={selectedNursery ? totalNursery.accessYear : total.accessYear} titleBgClass="bg-tomonote" />
                        </div>
                        <div className="col-xl col-lg-4 col-md-6 col-sm-6 col-12">
                            <CardStatBooks title="월 평균 실행 수" total={selectedNursery ? totalNursery.accessMonthAvg : total.accessMonthAvg} titleBgClass="bg-tomonote" />
                        </div>
                        <div className="col-xl col-lg-4 col-md-6 col-sm-6 col-12">
                            <CardStatBooks title="연간 콘텐츠 이용 수" total={selectedNursery ? totalNursery.playYear : total.playYear} titleBgClass="bg-tomobooks" />
                        </div>
                        <div className="col-xl col-lg-4 col-md-6 col-sm-6 col-12">
                            <CardStatBooks title="월 평균 이용 수" total={selectedNursery ? totalNursery.playMonthAvg : total.playMonthAvg} titleBgClass="bg-tomobooks" />
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <NurseryList list={data} hideBranch={loginBranchInfo != null} onSelectNursery={onSelectNursery} visible={!selectedNursery} />
                            {selectedNursery && (<ClassList list={dataNursery} />)} 
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export { StatOldTomobooksParent as default };
